export const producerWineTableFilter = () => {
  const producerPage = document.querySelector('.js-wine-academy-producer')
  const winePage = document.querySelector('.js-wine-academy-wine')
  if (producerPage || winePage) {
    const selector = document.querySelector('.js-choices-selector')
    const table = document.querySelector('.js-table')

    if (selector && table) {
      const tableSearch = document.querySelector('.gridjs-search-input')
      selector.addEventListener('change', e => {
        const producerValue = e.currentTarget.innerText
        if (producerValue === 'Select a wine') {
          tableSearch.value = ''
        } else {
          tableSearch.value = e.currentTarget.value
        }
        let event = new Event('input', {
          bubbles: true,
          cancelable: true,
        });

        tableSearch.dispatchEvent(event)
      })
    }
  }
}
